import { Col, Divider, Dropdown, Form, Modal, Row, Tabs,Spin } from 'antd'
import LeftArrow from 'assets/icons/LeftArrow'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import Flex from 'components/Flex'
import AntdInput from 'components/Form/Input'
import Label from 'components/Label/Label'
import StyledTabs from 'components/TabsPaneStyles/index'
import CopyAltIcon from 'components/icons/CopyAltIcon'
import CrossIcon from 'components/icons/CrossIcon'
import EmailAtIcon from 'components/icons/EmailAtIcon'
import ExclamationIcon from 'components/icons/ExclamationIcon'
import FacebookIcon1 from 'components/icons/FacebookIcon1'
import Happly from 'components/icons/Happly'
import LinkedIcon1 from 'components/icons/LinkedIcon1'
import UnHapply from 'components/icons/UnHapply'
import ApplyResumePopup from 'modules/Resume/DrawerComponents/ApplyResumePopup'
import {
  Address,
  BreadCrumns,
  Container,
  EligibleSubTitle,
  GetTPOContent,
  InnerBodyText,
  LapsedButton,
  Name,
  NameAdd,
  OuterDiv,
  RightContentOuter,
  RowContainer,
  SectionWrapper,
  SkillSubTitle,
  SubtitleSmall1,
  TimeDateDivision,
  TimeIcon,
  TimeInfo,
  TimeLabel,
  TopNav,
  YOPText,
} from 'modules/ViewSingleRole/Style/style'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import AddPlusRed from 'components/icons/AddPlusRed'
import CalendarIcon from 'components/icons/CalendarIcon'
import ClockIcon from 'components/icons/ClockIcon'
import ConstructionIcon from 'components/icons/ConstructionIcon'
import SaveFilled from 'components/icons/SaveFilled'
import SaveOutLine from 'components/icons/SaveOutLine'
import Share from 'components/icons/Share'
import TwitterIcon from 'components/icons/TwitterIcon'
import WhatsappIcon from 'components/icons/WhatsappIcon'
import Emptystates from 'components/icons/emptystates.svg'
import RoutePath from 'components/route_path/RoutePath'
import {
  Content,
  DisplayPad,
  MailSubHeading,
  RowPadding,
} from 'modules/ManageProfile/Style/style'
import InternshipDrawerModal from 'modules/Resume/DrawerComponents/ProjectDetails/InternshipDrawerModal'
import WorkExperienceModal from 'modules/Resume/DrawerComponents/ProjectDetails/WorkExperienceModal'
import ProjectModal from 'modules/Resume/DrawerComponents/ProjectDetails/ProjectModal'
import CourseTrainingModal from 'modules/Resume/DrawerComponents/ProjectDetails/CourseTrainingModal'
import EducationalModal from 'modules/Resume/DrawerComponents/EducationDetails/EducationalModal'
import {
  AndDivision,
  CenteredDiv,
  ColListIcon,
  Condition,
  DropRow,
  FlexWrap,
  RowListIcon,
  RowListLabel,
  ShareTitile,
  ShowDiv,
  SkillBox,
  SkillBoxRed,
  SkillList,
  TextWithIcon,
  TopHeader,
} from 'modules/ViewRole/Style/style'
import AboutCompany from 'modules/ViewSingleRole/Style/AboutCompany'
import ConfirmDrawer from 'modules/ViewSingleRole/Style/ConfirmDrawer'
import JobDescription from 'modules/ViewSingleRole/Style/JobDescription'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share'
import { COLORS } from 'theme'
import { dateConversion } from '../../utils/helpers'
import { getAppliedRoleMetrics } from '../Applied_Roles/actions'
import { StyledDiv } from '../Dashboard/Style/style'
import QuestionnaireModal from '../Roles/Style/QuestionnaireModal'
import SkillBasedRoleModal from '../Roles/Style/SkillBasedRoleModal'

import { CaretRightOutlined, LoginOutlined } from '@ant-design/icons'
import { Collapse } from 'antd'
import ConfirmationModal from 'components/ConfirmationModal'
import SuccessModal from 'components/SuccessModal'
import ProfileFormModal from 'modules/Roles/Style/ProfileFormModal'
import PopModal from 'modules/Roles/Style/PopModal'
import moment from 'moment'
import styled from 'styled-components'
import SuccessMessage from 'utils/SuccessMessage'

import CvProgressModal from 'modules/Roles/Style/CvProgressModal' // ← NEW
import { checkJobCategory } from 'utils/const'
import ErrorMessage from 'utils/ErrorMessage'
// import {  } from '../Resume/actions'
import { sendNotificationBulkEmail } from 'modules/ManageProfile/actions'
import ReactDOMServer from 'react-dom/server'
import EvaluationProcessScheduleTemplate from 'components/EmailTemplate/EvaluationProcessScheduleTemplate'

/* inside component */

const { Panel } = Collapse
const StyledQuestion = styled.div`
  background-color: ${props =>
    props.isEligible ? '#D6FFF2' : '#FFD6D6'} !important;
  color: #000000 !important;
  position: relative;
  padding: 5px !important;
  font-weight: 700;
  border-radius: 5px;
  line-height: 1.5715;
  margin-bottom: 10px;
  cursor: pointer;
`
const StyledPanel = styled(Panel)`
  .ant-collapse-header {
    background-color: ${props =>
      props.isEligible ? '#D6FFF2' : '#FFD6D6'} !important;
    color: #000000 !important;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: flex-start;
    padding: 5px !important;
    font-weight: 700;
    border-radius: 5px;
    line-height: 1.5715;
    cursor: pointer;
    transition: all 0.3s, visibility 0s;
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 15px 5px 15px 5px !important;
  }
  .ant-collapse-content {
    border-radius: 5px;
  }
`

const StyledCollapse = styled(Collapse)`
  background-color: white !important;
  margin-top: 20px;

  .ant-collapse-item {
    margin-bottom: 10px;
  }
`

const { TabPane } = Tabs

const ViewSingleRole = ({
  SaveRole,
  getSingleRoleDetails,
  viewRoleDetails,
  getRoleFloatDetails,
  getEligibleDetails,
  ApplyRole,
  collegeData,
  jobSharingEmail,
  getFunctionsList,
  functionsList,
  updateRoleFloatDetails,
  studentDetails,
  updateStudentData,
  getListOfSkills,
  getSingleEligibleRoleDetails,
  getCompTypeList,
  getStudentData,
  studentData,
  getStudentRuleSet,
  getTPOApprovalRequest,
  getViewedRoleUpdate,
  getNewRoleMetrics,
  updateStudent,
  getListOfCountries,
  getListOfState,
  getListOfCity,
  searchAPI,
  stateList,
  studentFormData,
  updateCvDetails,
  studentOptedStatus,
  optoutStatus,
  getCities,
  geStudentQuestionaireResult,
  deleteEducation,
  countryList,
  getStudentResumeData,
  getPendingData
}) => {
  console.log(viewRoleDetails,"viewRoleDetails",studentData)
  const navigate = useNavigate()
  const params = useParams()
  const dispatch = new useDispatch()
  const [shareOption, setShareOption] = useState(false)
  const [emailModel, setEmailModel] = useState(false)
  const [loading, setLoading] = useState(false)
  const [roleDrawer, setRoleDrawer] = useState(false)
  const [workExperienceDrawer, setWorkExperienceDrawer] = useState(false)
  const [selectedNew, setSelectedNew] = useState({})
  const [eligibilityCriteria, setEligibilityCriteria] = useState([])
  const { PIL_WEBSITE_URL } = process.env
  const shareUrl = `${PIL_WEBSITE_URL}/job/${params.CorpID}/${params.JobID}`
  const [roleTypewithComp, setRoleTypeWithComp] = useState([])
  const [studentRules, setStudentRules] = useState(null)
  const [messages, setMessages] = useState([])
  const [messagePopup, setMessagePopup] = useState([])
  const [applyBeforeConfirm, setApplyBeforeConfirm] = useState(false)
  const [appliedSuccessModal, setAppliedSuccessModal] = useState(false)
  const [externalConfirm, setExternalConfirm] = useState(false)
  const [externalLinkApply, setExternalLinkApply] = useState(false)
  const [isApproval, setIsApproval] = useState(false)
  const [isApprovalSuccessModal, setIsApprovalSuccessModal] = useState(false)
  const [exceptionBrand, setExceptionBrand] = useState([])
  const [modalVisibleData, setModalVisibleData] = useState(false)
  const [cvProgVisible, setCvProgVisible] = useState(false)
  const [cvProgPercent, setCvProgPercent] = useState(0)
  const [internshipDrawer, setInternshipDrawer] = useState(false)
  const [projectDrawer, setProjectDrawer] = useState(false)
  const [courseTrainingDrawer, setCourseTrainingDrawer] = useState(false)
  const [eduModalVisible, setEduModalVisible] = useState(false)
  const [firstTimeLoading, setFirstTimeLoading] = useState(true)
  const [resumePopupVisible, setResumePopupVisible] = useState(false)
const [selectedResumeId, setSelectedResumeId] = useState('PIL')

const { JBIMS_INSITITUTE_CAMPUS_ID } = process.env;
  const corporateIds = exceptionBrand?.map(item => item?.corporateId)
  // const [studentUpdatedData, setStudentUpdatedData] = useState(null)
  const isOptOut = optoutStatus?.optoutStatus?.currentCourse?.optOutStatus
  const campusDetails = useSelector(state => state?.studentData?.campusDetails)
  const accessLevel = campusDetails?.instituteSubscription?.accessLevel
  const [externalResumeApply,setExternalResumeApply] = useState(false)
  const [approvalResumeApply,setApprovalResumeApply] = useState(false)
  const [selectFileResume,setSelectedFileResume] = useState(null)
  const getCategoryDetails = (minCompensation, maxCompensation) => {
    if (
      roleTypewithComp?.length === 0 ||
      viewRoleDetails?.role?.jobCategory != 'PLACEMENT'
    ) {
      return { orderNo: null, name: null } // Return null for both if no roleTypewithComp? exist
    }

    let matchingCategory = roleTypewithComp?.find(
      category =>
        maxCompensation >= category.minCTC &&
        maxCompensation <= (category.maxCTC || Number.MAX_SAFE_INTEGER)
    )

    if (matchingCategory) {
      return { orderNo: matchingCategory.orderNo, name: matchingCategory.name }
    }

    return { orderNo: null, name: null }
  }
  const categoryDetails = getCategoryDetails(
    viewRoleDetails?.role?.minCompensation,
    viewRoleDetails?.role?.maxCompensation
  )
  const splitDate = () => {
    let date = {
      minYear: '0',
      maxYear: '0',
      minMonth: '0',
      maxMonth: '0',
    }
    if (viewRoleDetails?.role?.yearOfExperience?.length > 1) {
      let min = String(viewRoleDetails?.role?.yearOfExperience?.[0])?.split('.')
      let max = String(viewRoleDetails?.role?.yearOfExperience?.[1])?.split('.')
      if (min?.length) {
        date.minYear = min?.[0] ?? 0
        date.minMonth = min?.[1] ?? 0
      }
      if (max?.length) {
        date.maxYear = max?.[0] ?? 0
        date.maxMonth = max?.[1] ?? 0
      }
    }
    return date
  }
  const date = splitDate()
  useEffect(() => {
    getSingleRoleDetails(params.CorpID, params.JobID)
    fetchEligleDetails()
    fetchInitialComType()
    studentOptedStatus()
  }, [])

  const UpdatedSkills = () => {
    getSingleRoleDetails(params.CorpID, params.JobID)
    fetchEligleDetails()
    fetchStudentRuleSet()
  }

  const fetchEligleDetails = async () => {
    setFirstTimeLoading(true)
    let data = await getSingleEligibleRoleDetails(params.CorpID, params.JobID)
    setEligibilityCriteria(data)
    setFirstTimeLoading(false)
    return data
  }
  const fetchEligleDetailsNotLoading = async () => {
    let data = await getSingleEligibleRoleDetails(params.CorpID, params.JobID)
    setEligibilityCriteria(data)
    return data
  }
  const fetchInitialComType = async () => {
    let result = await getCompTypeList()
    setExceptionBrand(result?.data?.data?.instituteRule?.brands?.list)
    setRoleTypeWithComp(
      result?.data?.data?.instituteRule?.compensationThreshold?.isEnabled
        ? result?.data?.data?.instituteRule?.compensationThreshold
            ?.compensationList
        : []
    )
  }

  useEffect(() => {
    fetchStudentRuleSet()
  }, [])

  useEffect(() => {
    const checks = []
    const popupChecks = []

    const addMessage = (id, rawMessage) => {
      const formattedMessage = `${checks?.length + 1}. ${rawMessage}`
      popupChecks.push(rawMessage)
      checks.push({ id, message: formattedMessage })
    }

    if (
      viewRoleDetails?.restrictedReason?.absentLimit &&
      !viewRoleDetails.restrictedReason.absentLimit.isEligible &&
      viewRoleDetails.restrictedReason.absentLimit.limit <=
        viewRoleDetails.restrictedReason.absentLimit.used
    ) {
      addMessage(
        1,
        `You’ve been restricted due to missing ${viewRoleDetails.restrictedReason.absentLimit.limit} evaluation processes`
      )
    }

    if (
      viewRoleDetails?.restrictedReason?.applyLimit &&
      !viewRoleDetails.restrictedReason.applyLimit.isEligible &&
      viewRoleDetails.restrictedReason.applyLimit.limit <=
        viewRoleDetails.restrictedReason.applyLimit.used
    ) {
      addMessage(2, `You have used your maximum applications`)
    }

    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.limit <=
        viewRoleDetails.restrictedReason.offerLimit.used
    ) {
      addMessage(
        3,
        `You already have <span> ${
          viewRoleDetails?.restrictedReason?.offerLimit?.placementType ===
          'OFFER_ACCEPTED'
            ? 'Offer Accepted'
            : 'Intent to Offer'
        } </span> from ${viewRoleDetails.restrictedReason.offerLimit.limit} ${
          viewRoleDetails.restrictedReason.offerLimit.limit > 1
            ? 'Roles'
            : 'Role'
        }`
      )
    }
    if (
      viewRoleDetails?.restrictedReason?.offerLimit?.isMinimumThresholdReached
    ) {
      addMessage(8, `You have exceeded minimum threshold`)
    }
    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.exceptionalFor.includes(
        'multiplesAmount'
      )
    ) {
      addMessage(
        4,
        `You are applying for a role with a compensation range lower than <span> ${viewRoleDetails.restrictedReason.offerLimit.multiples}x </span> your current CTC`
      )
    }

    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.exceptionalFor.includes(
        'absoluteAmount'
      )
    ) {
      addMessage(
        5,
        `You are applying for a role with a package that is below ₹${viewRoleDetails.restrictedReason.offerLimit.absoluteAmount.toLocaleString()}`
      )
    }

    if (
      viewRoleDetails?.restrictedReason?.offerLimit &&
      viewRoleDetails.restrictedReason.offerLimit.exceptionalFor.includes(
        'compensationRange'
      )
    ) {
      const currentPackageName = viewRoleDetails.restrictedReason.offerLimit
        .currentPackage
        ? viewRoleDetails.restrictedReason.offerLimit.currentPackage.name
        : 'current package'
      addMessage(
        6,
        `Your highest ${
          viewRoleDetails?.restrictedReason?.offerLimit?.placementType ===
          'OFFER_ACCEPTED'
            ? 'Offer Accepted'
            : 'Intent to Offer'
        } role is from the <span>"${currentPackageName}"</span> comp. range, and you are applying for a lower comp. range ${
          categoryDetails?.name ? `<span>"${categoryDetails.name}"</span>` : ''
        } role`
      )
    }
    if (
      viewRoleDetails?.restrictedReason?.initialMissLimit &&
      !viewRoleDetails.restrictedReason.isInitialMissed &&
      viewRoleDetails.restrictedReason.initialMissLimit.limit <=
        viewRoleDetails.restrictedReason.initialMissLimit.used
    ) {
      addMessage(
        7,
        `You’ve been restricted due to missing initial ${
          viewRoleDetails.restrictedReason.initialMissLimit.used > 1
            ? viewRoleDetails.restrictedReason.initialMissLimit.used + ' roles'
            : viewRoleDetails.restrictedReason.initialMissLimit.used + ' role'
        } eventhough you eligible`
      )
    }
    setMessages(checks)
    setMessagePopup(popupChecks)
  }, [viewRoleDetails?.restrictedReason])
  const fetchStudentRuleSet = async () => {
    let result = await getStudentRuleSet()
    setStudentRules(result?.data?.data)
  }
  const [drawer, setDrawer] = useState(false)
  const [selected, setSelected] = useState({})
  const [modalVisible, setModalVisible] = useState(false)
  const [skillVisible, setSkillVisible] = useState(false)
  const [locationVisible, setLocationVisible] = useState(false)
  const [expVisible, setExpVisible] = useState(false)
  const [expDrawer, setExpDrawer] = useState(false)
  const [activeKey, setActiveKey] = useState(null)

  const handleCollapseChange = key => {
    setActiveKey(key === activeKey ? null : key)
  }
  const listOfStudentSkills = []
  const [updateResponse, setUpdateResponse] = useState(false)

  const [questionnaireModal, setQuestionnaireModal] = useState(false)

  const eligibleList = useSelector(
    state => state?.rolesListData.eligibleDetails
  )
  const roleFloatList = useSelector(
    state => state?.rolesListData.roleFloatDetails
  )
  const pendingData = useSelector(
    state => state?.resumeData?.pendingData
  )
useEffect(() => {
  (getPendingData());
}, []);

  const showDrawerNew = param => {
    setSelected(param)
  }

  const onConfirmModalClose = async () => {
    setApplyBeforeConfirm(false)
    setAppliedSuccessModal(false)
    setExternalConfirm(false)
    setIsApproval(false)
    setIsApprovalSuccessModal(false)
  }
  const onExternalApplyClose = async () => {
    setExternalLinkApply(false)
    await updateStudent({ lastAppliedJobIds: [] })
  }
  const onRoleAccept = () => {
    setApplyBeforeConfirm(false)
    setAppliedSuccessModal(true)
    onApplyClick()
  }

  const onExternalRedirect = async () => {
    let link = viewRoleDetails?.role?.externalLink
    if (
      !viewRoleDetails?.role?.externalLink.startsWith('http://') &&
      !viewRoleDetails?.role?.externalLink.startsWith('https://')
    ) {
      link = 'https://' + viewRoleDetails?.role?.externalLink
    }

    const newTab = window.open('', '_blank')

    setTimeout(() => {
      newTab.location.href = link
    }, 100)
    await updateStudent({ lastAppliedJobIds: [viewRoleDetails?.role?.id] })

    setExternalConfirm(false)
    setExternalLinkApply(true)
  }
  const onExternalApply = async () => {
    //externalApplyClicked()
    setResumePopupVisible(true)
    setExternalResumeApply(true)
    await updateStudent({ lastAppliedJobIds: [] })

    setExternalLinkApply(false)
  }

  const externalApplyClicked = async (file) => {
    
    console.log("external Apply Click Or Questionary",file)
      setResumePopupVisible(false)

    const data = { ...viewRoleDetails, isApplied: 1 , cvUrl: file?.url || null , isSystemResume: file?.type === 'SYSTEM' ? true : false}
    const roleAppliedResult = await ApplyRole(data, false, false)
    if (roleAppliedResult?.status == 201) {
      setLoading(false)
      setExternalResumeApply(false)
      setQuestionnaireModal(false)
      // if (viewRoleDetails?.role?.questionBankRoleMap?.length) {
      //   setQuestionnaireModal(true)
      // }

      dispatch(getAppliedRoleMetrics())
      getSingleRoleDetails(params.CorpID, params.JobID)
      fetchEligleDetails()
      fetchStudentRuleSet()
    }
  }
  const checkJobTypeLevel = (data, YOE) => {
    const transformedData = data?.map(item => {
      switch (item) {
        case 'ENTRY':
          return ' Entry Level'
        case 'INTERN':
          return ' Internship'
        case 'EXPERIENCED':
          return YOE?.length > 0
            ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
            : ` 0 - 1 Yrs Experience `
        default:
          return item
      }
    })

    return transformedData?.toString()
  }
  const openModal = async () => {
    setModalVisible(false)
    showDrawerNew(params.JobID)
    setSelectedNew(viewRoleDetails)
    const itemId = params.JobID
    let res = await getEligibleDetails({ roleID: itemId, setLoading })
    if (res?.skills?.isEligible) {
      setSkillVisible(true)
      setUpdateResponse(true)
    }
    if (res?.locations?.isEligible) {
      setLocationVisible(true)
    }
    if (res?.experience?.isEligible) {
      setExpVisible(true)
    }
    getRoleFloatDetails({ setLoading })
    setTimeout(() => {
      setRoleDrawer(true)
    }, 500)
  }

  const closeModal = () => {
    setModalVisible(false)
  }

  const onApplyClick = async (file) => {
    if (!viewRoleDetails?.isRestricted) {
      const data = { ...viewRoleDetails, isApplied: 1,  cvUrl: file?.url || null , isSystemResume: file?.type === 'SYSTEM' ? true : false}
      const roleAppliedResult = await ApplyRole(data, false, false)
      if (roleAppliedResult?.status == 201) {
        setLoading(false)
        setAppliedSuccessModal(true)
        if (viewRoleDetails?.role?.questionBankRoleMap?.length > 0 &&
          eligibilityCriteria?.questionarie?.student?.length === 0) {
          setQuestionnaireModal(true)
        }
        if (viewRoleDetails?.role?.rolePublishedBy === "INSTITUTE" && viewRoleDetails?.role?.interviewWorkFlow?.rounds?.length > 0) {
          // Build template data and send evaluation schedule email to the student
          try {
            const studentEmail =
              studentData?.studentPersonalProfile?.primaryEmail ||
              studentData?.admin?.email

            const studentName =
              studentData?.fullName ||
              `${studentData?.admin?.first_name || ''} ${
                studentData?.admin?.last_name || ''
              }`.trim()

            const templateData = {
              studentName: studentName || '',
              roleName: viewRoleDetails?.role?.tittle || '',
              companyName:
                viewRoleDetails?.role?.company?.companyName ||
                viewRoleDetails?.role?.corporate?.name ||
                '',
              rounds: viewRoleDetails?.role?.interviewWorkFlow?.rounds || [],
            }

            const html = ReactDOMServer.renderToStaticMarkup(
              <EvaluationProcessScheduleTemplate data={templateData} />
            )

            if (studentEmail) {
              const emailPayload = [
                {
                  to: studentEmail,
                  subject: `Evaluation process for ${
                    templateData.roleName || 'the role'
                  } - ${templateData.companyName || 'the company'}`,
                  htmlBody: html,
                },
              ]
              await dispatch(sendNotificationBulkEmail(emailPayload))
            }
          } catch (e) {
            console.error('Failed to send evaluation schedule email', e)
          }
        }

        dispatch(getAppliedRoleMetrics())
        getSingleRoleDetails(params.CorpID, params.JobID)
        fetchEligleDetails()
        fetchStudentRuleSet()
      }
    } else {
      dispatch(getAppliedRoleMetrics())
      getSingleRoleDetails(params.CorpID, params.JobID)
      fetchEligleDetails()
      fetchStudentRuleSet()
      setApprovalResumeApply(true)
      setResumePopupVisible(true)
      //setIsApproval(true)
    }
  }
const onApplyWithResume = async (select) => {
  setSelectedFileResume(null)
  // if (!resumeId) {
  //   ErrorMessage("Please select a resume");
  //   return;
  // }
  console.log("CONSOLE Normal APPLy:", select);
  // close popup
  setResumePopupVisible(false);

  // EXACT same old behavior as old confirm popup Apply button
  if(externalResumeApply)
    await externalApplyClicked(select)
  else if(approvalResumeApply){
    setIsApproval(true)
    setSelectedFileResume(select)
  }  
  else
    await onApplyClick(select);
};
  const showDrawer = async viewRoleDetails => {
    let studentUpdatedData = await getStudentData()
    let eligleDetails = await fetchEligleDetailsNotLoading()
    if (
      eligleDetails?.isEligible &&
      !viewRoleDetails?.isExpired &&
      (!viewRoleDetails?.isRestricted || viewRoleDetails?.isExternalLink) &&
      viewRoleDetails?.role?.status != -1 &&
      studentUpdatedData?.currentState === 4  && (eligleDetails?.isExperienceEligible &&
        eligleDetails?.isLocationEligible &&
        eligleDetails?.isSkillEligible)
    ) {
      setSelected(viewRoleDetails)
      if (viewRoleDetails?.role?.questionBankRoleMap?.length && !eligleDetails?.isQuestionarieEligible) {
        setQuestionnaireModal(true)
      } else if (
        (viewRoleDetails?.role?.corporate?.id ||
          viewRoleDetails?.role?.companyId) &&
        viewRoleDetails?.role?.id
      ) {
        if (viewRoleDetails?.role?.externalLink) {
          setExternalConfirm(true)
        } else {
          setResumePopupVisible(true)
        }
        //  onApplyClick(isCorporateRole)
      }
    } else if (
      !viewRoleDetails?.isExpired &&
      (!eligleDetails?.isExperienceEligible ||
        !eligleDetails?.isLocationEligible ||
        !eligleDetails?.isSkillEligible) &&
      studentData?.status != -1 &&
      viewRoleDetails?.role?.status != -1 &&
      studentUpdatedData?.currentState === 4 
     // eligleDetails?.isDegreeEligible
    ) {
      if(eligleDetails?.isDegreeEligible)
      {
      setSelected(viewRoleDetails)
      //Modal Condition
        if(JBIMS_INSITITUTE_CAMPUS_ID !== campusDetails?.id)
          openModal()
        else
          ErrorMessage("Oh no! You are not eligible to apply for this role.")
      }
      else{
        ErrorMessage("You Are Not Eligible To Apply This Role due to mismtach degree")
      }
      //setModalVisible(true)
    } else if (studentUpdatedData?.currentState !== 4 && (accessLevel === 0 || accessLevel === 2)) {
      setModalVisibleData(true)
    } else if (
      viewRoleDetails?.role?.questionBankRoleMap?.length > 0 &&
      !eligleDetails?.isQuestionarieEligible &&
      viewRoleDetails?.isRestricted &&
      studentUpdatedData?.currentState === 4 &&
      eligleDetails?.isArrearEligible
        && eligleDetails?.isDegreeEligible && eligleDetails?.isExperienceEligible && 
        eligleDetails?.isLocationEligible && eligleDetails?.isScoreEligible && 
        eligleDetails?.isSkillEligible && eligleDetails?.isYearOfPassingEligible &&
        eligibilityCriteria?.questionarie?.student?.length === 0
    ) {
      setQuestionnaireModal(true)
    } else if (
      viewRoleDetails?.role?.questionBankRoleMap?.length > 0 &&
      !eligleDetails?.isQuestionarieEligible &&
      studentUpdatedData?.currentState === 4 &&
      eligleDetails?.isArrearEligible
        && eligleDetails?.isDegreeEligible && eligleDetails?.isExperienceEligible && 
        eligleDetails?.isLocationEligible && eligleDetails?.isScoreEligible && 
        eligleDetails?.isSkillEligible && eligleDetails?.isYearOfPassingEligible &&
        eligibilityCriteria?.questionarie?.student?.length === 0
    ) {
      setQuestionnaireModal(true)
    }
  }

  const onApplyClickSkilled = () => {
    if (!viewRoleDetails?.isRestricted) {
      if (viewRoleDetails?.role?.questionBankRoleMap?.length > 0 &&
        eligibilityCriteria?.questionarie?.student?.length === 0) {
        setQuestionnaireModal(true)
      } else if (
        (viewRoleDetails?.role?.corporate?.id ||
          viewRoleDetails?.role?.companyId) &&
        viewRoleDetails?.role?.id
      ) {
        if (viewRoleDetails?.role?.externalLink) {
          setExternalConfirm(true)
        } else {
          setResumePopupVisible(true)
        }
        //  onApplyClick(isCorporateRole)
      }
    } else {
      dispatch(getAppliedRoleMetrics())
      getSingleRoleDetails(params.CorpID, params.JobID)
      fetchEligleDetails()
      fetchStudentRuleSet()
      setApprovalResumeApply(true)
      setResumePopupVisible(true)
      //setIsApproval(true)
    }
  }

  useEffect(() => {
    updateViewedDetail()
  }, [])

  const updateViewedDetail = async () => {
    await getViewedRoleUpdate(params?.JobID)
    getNewRoleMetrics()
  }
  const getApproval = () => {
    //setIsApproval(true)
    if(viewRoleDetails?.role?.externalLink){
      setIsApproval(true)
    }
    else{
    setApprovalResumeApply(true)
    setResumePopupVisible(true)
    }
  }
  const onApprovalClick = async () => {
    setIsApproval(false)
    let payLoad = {
      tpoStatus: 0,
      isApplied: 0,
      cvUrl: selectFileResume?.url,
      isSystemResume: selectFileResume?.type === 'SYSTEM' ? true : false
    }
console.log(selectFileResume,"selectFileResume")
    if(payLoad?.cvUrl === null){
      delete payLoad.cvUrl
      payLoad.isSystemResume = true
    }
    const response = await geStudentQuestionaireResult(
      params.CorpID,
      params.JobID
    )

    if (response.status === 200) {
      if (response?.data?.data?.count != response?.data?.data?.mandatoryCount) {
        payLoad.isApplied = -1
      }
    }

    await getTPOApprovalRequest(payLoad, viewRoleDetails?.role?.id)
    UpdatedSkills()
    setIsApprovalSuccessModal(true)
  }
  const closeQuestionnaireModal = async () => {
    await getSingleRoleDetails(params.CorpID, params.JobID)
    fetchEligleDetails()
    fetchStudentRuleSet()
    setQuestionnaireModal(false)
  }
  const openQuestinnaire = () => {
    // setQuestionnaireModal(false)
    navigate(
      `/roles/viewRole/${viewRoleDetails?.role?.corporate?.id}/${viewRoleDetails?.role?.id}/questionnaire`
    )
  }

  const ShareWork = () => {
    setShareOption(true)
  }
  const ShareCancel = () => {
    setShareOption(false)
  }

  const copyLink = () => {
    let copyText = document.getElementById('socilamedialink')
    copyText.select()
    navigator.clipboard.writeText(copyText.value)
    if (copyText.value?.length != 0) {
      SuccessMessage('Link Copied!')
    }
  }

  const handleEmailOnClick = () => {
    setEmailModel(true)
  }
  const handleEmailCancel = () => {
    setEmailModel(false)
  }
  const onEmailEntered = e => {}
  const sendEmailOTP = async values => {
    let payload = {
      email: values?.Email,
      link: shareUrl,
    }
    jobSharingEmail(payload)
    setEmailModel(false)
  }
  function formatAMPM(date) {
    let hours = date.getUTCHours()
    let minutes = date.getUTCMinutes()
    const ampm = hours >= 12 ? 'PM' : 'AM'
    hours = hours % 12
    hours = hours || 12 // Handle midnight (0 hours)
    minutes = minutes < 10 ? '0' + minutes : minutes
    const strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  const [showAll, setShowAll] = useState(false)
  const totalIntegrations = eligibilityCriteria?.degree?.reduce(
    (count, item) => {
      return (
        count +
        item?.qualification?.reduce((subCount, qual) => {
          return (
            subCount +
            item?.selected?.[qual]?.reduce((subSubCount, subitem) => {
              return subitem.isAllDegree
                ? subSubCount
                : subSubCount +
                    (subitem?.streams?.reduce((streamCount, stream) => {
                      return (
                        streamCount + (stream?.specialisations?.length || 1)
                      )
                    }, 0) || 1)
            }, 0)
          )
        }, 0)
      )
    },
    0
  )
  const showItemCount = showAll ? totalIntegrations : 5
  let displayedIntegrations = 0
  let mandatorySkillNames = eligibilityCriteria?.skill?.role ?? null
  const hasNonEmptySkillSet = mandatorySkillNames?.otherSkillsNames?.some(
    skillSet => skillSet?.skillNames?.length > 0
  )
  const menu = (
    <DropRow>
      <TopHeader row spaceBetween alignCenter>
        <ShareTitile flexStart>Share this role</ShareTitile>
        <div style={{ cursor: 'pointer', marginTop: 5 }}>
          <Avatar onClick={ShareCancel} size={20} src={<CrossIcon />} />
        </div>{' '}
      </TopHeader>
      <Divider />
      <RowListIcon row>
        <ColListIcon column alignCenter>
          <LinkedinShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<LinkedIcon1 />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </LinkedinShareButton>

          <RowListLabel>Linked In</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <FacebookShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<FacebookIcon1 />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </FacebookShareButton>
          <RowListLabel>Facebook</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <TwitterShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<TwitterIcon />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </TwitterShareButton>

          <RowListLabel>Twitter</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <EmailShareButton onClick={handleEmailOnClick} url={shareUrl}>
            <Avatar
              size={72}
              src={<EmailAtIcon />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </EmailShareButton>

          <RowListLabel>E-Mail</RowListLabel>
        </ColListIcon>
        <ColListIcon column alignCenter>
          <WhatsappShareButton url={shareUrl}>
            <Avatar
              size={72}
              src={<WhatsappIcon />}
              background={'#9D9D9D0A'}
              padding={'25px'}
            />
          </WhatsappShareButton>
          <RowListLabel>Whatsapp</RowListLabel>
        </ColListIcon>
      </RowListIcon>
      <CenteredDiv>Or share with link</CenteredDiv>
      <AntdInput
        id={'socilamedialink'}
        value={shareUrl}
        disabled={true}
        suffix={
          <StyledDiv
            style={{ cursor: 'pointer', marginTop: 5 }}
            onClick={copyLink}
          >
            <CopyAltIcon />
          </StyledDiv>
        }
      />
    </DropRow>
  )

  useEffect(() => {
    getStudentData()
    fetchStudentData()
  }, [])

  const fetchStudentData = async () => {
    let data = await getStudentData()

    return data
  }
  const CheckIcon = corporate => {
    // if (corporate?.logo) {
    //   return <Avatar size={64} src={corporate?.logo} />
    // } else {
    return (
      <Avatar
        background
        size={65}
        shape={'square'}
        src={corporate?.corporate?.logo ?? corporate?.company?.logo?.url}
        IconName={
          corporate?.corporate?.name?.[0] ??
          corporate?.corporate?.companyName?.[0]
        }
        font={18}
      />
    )
    // }
  }
  const HeartClicked = () => {
    let payLoad = {
      id: viewRoleDetails?.role?.id,
      isSaved: viewRoleDetails?.isSaved === 1 ? 0 : 1,
    }
    SaveRole(payLoad)
  }

  const DateCompare = data => {
    if (viewRoleDetails?.role?.status == -1) {
      return <Button.Danger text={'Application Cancelled'} width={'100%'} />
    } else if (
      viewRoleDetails?.isExternalLink &&
      eligibilityCriteria?.isEligible
    ) {
      return (
        <Button.Primary
          onClick={() => showDrawer(viewRoleDetails)}
          color={'#3249D7'}
          background={'#EAEDFB'}
          icon={
            <span style={{ marginLeft: '7px' }}>
              <LoginOutlined />
            </span>
          }
          text={`Apply  ` + '   '}
          width={'100%'}
          disabled={studentData?.status == -1 || isOptOut == 1 || isOptOut == 4 ||  ((accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4)}
        />
      )
    }
    else if(viewRoleDetails?.tpoStatus != 0 &&
      viewRoleDetails?.tpoStatus != -1 &&
      viewRoleDetails?.tpoStatus != 1 &&
      studentData?.status != -1 &&
      optoutStatus?.optoutStatus?.currentCourse
        ?.optOutStatus != 1 &&
      optoutStatus?.optoutStatus?.currentCourse
        ?.optOutStatus != 4 && viewRoleDetails?.isRestricted &&  !viewRoleDetails?.isExpired &&
        eligibilityCriteria?.isEligible){
          return(
          <Button.Primary
          onClick={() => getApproval()}
          text={'Get TPO approval'}
          width={'100%'}
        />
          )
    }
    else if (
      viewRoleDetails?.tpoStatus === 0 &&
      !viewRoleDetails?.isExpired
    ) {
      return (
        <Button.SecondaryColor
          text={'TPO Approval Sent'}
          width={'100%'}
          style={{
            whiteSpace: 'pre-line',
            lineHeight: '1.2',
            textAlign: 'center',
          }}
        />
      )
    } else if (viewRoleDetails?.tpoStatus === 0 && viewRoleDetails?.isExpired) {
      return (
        <LapsedButton
          width={'100%'}
          style={{
            whiteSpace: 'pre-line',
            lineHeight: '1.2',
            textAlign: 'center',
          }}
        >
          {'TPO Approval Lapsed'}
        </LapsedButton>
      )
    } else if (viewRoleDetails?.tpoStatus === -1) {
      return (
        <LapsedButton
          width={'100%'}
          background={'#FFEEEC'}
          color={'#E35E50'}
          style={{
            whiteSpace: 'pre-line',
            lineHeight: '1.2',
            textAlign: 'center',
          }}
        >
          {'TPO Approval Declined'}
        </LapsedButton>
      )
    } else if (!viewRoleDetails?.isExpired) {
      if (viewRoleDetails?.isApplied === -1) {
        return <Button.SecondaryColor width={'100%'} text={'Applied'} />
      } else if (
        !eligibilityCriteria?.isEligible ||
        viewRoleDetails?.isRestricted
      ) {
        // if(viewRoleDetails?.role?.externalLink){
        //   return (
        //     <Button.Primary
        //       onClick={() => showDrawer(viewRoleDetails)}
        //       color={'#3249D7'}
        //       background={'#EAEDFB'}
        //       icon={
        //         <span style={{ marginLeft: '7px' }}>
        //           <LoginOutlined />
        //         </span>
        //       }
        //       text={`Apply  ` + '   '}
        //       width={'100%'}
        //       disabled={studentData?.status == -1 || isOptOut == 1 || isOptOut == 4 || ((accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4)}
        //     />
        //   );
        // }
        // else{
        return (
          <Button.Primary
            onClick={() => showDrawer(viewRoleDetails)}
            color={'#3249D7'}
            background={'#EAEDFB'}
            text={(accessLevel === 1 || accessLevel === 3) ? 'Check Eligibility' : 'Apply'}
           // text={'Apply'}
            width={'100%'}
            style={{
              whiteSpace: 'pre-line',
              lineHeight: '1.2',
              textAlign: 'center',
            }}
            //
            disabled={studentData?.status == -1 || isOptOut == 1 || isOptOut == 4 || ((accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4)
              || (JBIMS_INSITITUTE_CAMPUS_ID === campusDetails?.id && (!eligibilityCriteria?.isExperienceEligible ||
        !eligibilityCriteria?.isLocationEligible ||
        !eligibilityCriteria?.isSkillEligible || !eligibilityCriteria?.isDegreeEligible ))
            }
          />
        )
      // }
      } else {
        if (viewRoleDetails?.role?.externalLink) {
          return (
            <Button.Primary
              onClick={() => showDrawer(viewRoleDetails)}
              color={'#3249D7'}
              background={'#EAEDFB'}
              icon={
                <span style={{ marginLeft: '7px' }}>
                  <LoginOutlined />
                </span>
              }
              text={`Apply  ` + '   '}
              width={'100%'}
              disabled={studentData?.status == -1 || isOptOut == 1 || isOptOut == 4 || ((accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4)}
            />
          )
        } else {
          return (
            <Button.Primary
              onClick={() => showDrawer(viewRoleDetails)}
              color={'#3249D7'}
              background={'#EAEDFB'}
              text={'Apply'}
              width={'100%'}
              disabled={studentData?.status == -1 || isOptOut == 1 || isOptOut == 4 || ((accessLevel === 1 || accessLevel === 3) && studentData?.currentState < 4)}
            />
          )
        }
      }
    } else {
      return <Button.Danger text={'Application Closed'} width={'100%'} />
    }
  }
  const handleSubmit = () => {
  }
  const ExtraAction = () => {
    return (
      <Container alignEnd>
        {/* {viewRoleDetails?.isApplied === 0 ? (
            DateCompare()
          ) : viewRoleDetails?.isApplied === -1 ? (
            <Button.Success
              icon={<Avatar size={20} src={<CheckTick />} />}
              text={'Applied'}
            />
          ) : (
            <Button.Success
              icon={<Avatar size={20} src={<CheckTick />} />}
              text={'Applied'}
              width={'300px'}
            />
          )} */}
        {/* &nbsp;&nbsp; &nbsp;&nbsp; */}
        <Button.Round
          padding={'10px'}
          onClick={HeartClicked}
          icon={
            <>
              {viewRoleDetails?.isSaved == 1 ? <SaveFilled /> : <SaveOutLine />}
            </>
          }
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Dropdown onClick={ShareWork} overlay={menu} visible={shareOption}>
          <Button.Round icon={<Share />} />
        </Dropdown>
      </Container>
    )
  }
  return (
    <>
    {firstTimeLoading ? <Spin size="large" /> :
      <SectionWrapper column>
        <OuterDiv>
          <RowContainer>
            <Col span={16}>
              <TopNav>
                <BreadCrumns>
                  <Link style={{ margin: '2px 8px 0px 0px ' }} to="/roles">
                    <LeftArrow />
                  </Link>
                  <RoutePath from="Role" on="Job Details" path="/roles" />
                </BreadCrumns>
                <Divider style={{ margin: '20px 0px' }} />
                {(viewRoleDetails?.role?.corporate ||
                  viewRoleDetails?.role?.company) && (
                  <Flex centerVertically alignCenter style={{ margin: 15 }}>
                    {CheckIcon(viewRoleDetails?.role)}
                    <NameAdd column flexStart>
                      <Name>
                        {viewRoleDetails?.role?.corporate?.name ||
                          viewRoleDetails?.role?.company?.companyName}
                      </Name>
                      <Address>
                        {viewRoleDetails?.role?.corporate?.industry ||
                          viewRoleDetails?.role?.company?.sector}
                      </Address>
                    </NameAdd>
                  </Flex>
                )}
              </TopNav>
              <StyledTabs
                width={'100%'}
                tabBarExtraContent={ExtraAction()}
                defaultActiveKey="1"
              >
                <TabPane tab="Job Description" key="1">
                  <JobDescription
                    viewRoleData={viewRoleDetails}
                    collegeData={collegeData}
                    getRoleFloatDetails={getRoleFloatDetails}
                    getEligibleDetails={getEligibleDetails}
                    getFunctionsList={getFunctionsList}
                    functionsList={functionsList}
                    updateRoleFloatDetails={updateRoleFloatDetails}
                    studentDetails={studentDetails}
                    updateStudentData={updateStudentData}
                    onApplyClick={onApplyClick}
                    roleTypewithComp={roleTypewithComp}
                    corporateIds={corporateIds}
                  />
                </TabPane>

                <TabPane tab="About Company" key="2">
                  <AboutCompany viewRoleData={viewRoleDetails} />
                </TabPane>
              </StyledTabs>
            </Col>
            <Col span={8}>
              <RightContentOuter>
                <div>
                  <TimeInfo>
                    <Flex gap="5px" centerVertically>
                      <TimeIcon>
                        <CalendarIcon customColor={'#CCCFD6'} />
                      </TimeIcon>
                      <SubtitleSmall1 marginbottom="0" capitalize={true}>
                        <TimeDateDivision>
                          <TimeLabel title>Start date</TimeLabel>
                          <TimeLabel color={COLORS.GREY_T_30}>
                            {dateConversion({
                              date: viewRoleDetails?.role?.startDate,
                              convertTo: 'Date/Month/Year',
                            })}
                          </TimeLabel>
                        </TimeDateDivision>
                      </SubtitleSmall1>
                    </Flex>
                  </TimeInfo>
                </div>
                <Row style={{ margin: '10px 0px' }}>
                  <Col span={12}>
                    <TimeInfo>
                      <Flex gap="5px" centerVertically>
                        <TimeIcon>
                          <CalendarIcon customColor={'#CCCFD6'} />
                        </TimeIcon>
                        <SubtitleSmall1 marginbottom="0" capitalize={true}>
                          <TimeDateDivision>
                            <TimeLabel title>End date</TimeLabel>
                            <TimeLabel color={COLORS.GREY_T_30}>
                              {dateConversion({
                                date: viewRoleDetails?.role?.endDate,
                                convertTo: 'Date/Month/Year',
                              })}
                            </TimeLabel>
                          </TimeDateDivision>
                        </SubtitleSmall1>
                      </Flex>
                    </TimeInfo>
                  </Col>
                  <Col span={11} style={{ marginLeft: '10px' }}>
                    <TimeInfo>
                      <Flex gap="5px" centerVertically>
                        <TimeIcon>
                          <ClockIcon color={'#CCCFD6'} />
                        </TimeIcon>
                        <SubtitleSmall1 marginbottom="0" capitalize={true}>
                          <TimeDateDivision>
                            <TimeLabel title>End Time</TimeLabel>
                            <TimeLabel color={COLORS.GREY_T_30}>
                              {formatAMPM(
                                new Date(viewRoleDetails?.role?.endDate)
                              )}
                            </TimeLabel>
                          </TimeDateDivision>
                        </SubtitleSmall1>
                      </Flex>
                    </TimeInfo>
                  </Col>
                </Row>
                <Divider style={{ margin: '15px 0px' }} />
                <Flex>
                  <Avatar size={20} src={<ConstructionIcon />} />
                  &nbsp;&nbsp;
                  <EligibleSubTitle>Eligibility Criteria </EligibleSubTitle>
                </Flex>
                <StyledCollapse
                  ghost
                  expandIconPosition="end"
                  expandIcon={({ isActive }) => (
                    <CaretRightOutlined rotate={isActive ? 90 : 0} />
                  )}
                  activeKey={activeKey}
                  onChange={handleCollapseChange}
                >
                  <StyledPanel
                    header="Degree & Departments"
                    key="1"
                    isEligible={eligibilityCriteria?.isDegreeEligible}
                  >
                    {eligibilityCriteria?.degree?.length > 0 && (
                      <div>
                        <TextWithIcon wrap="wrap" gap="10px">
                          {eligibilityCriteria?.degree?.map((item, key) => {
                            if (displayedIntegrations >= showItemCount)
                              return null
                            return (
                              <React.Fragment key={key + 'key'}>
                                {item.qualification?.map((qual, index) => (
                                  <React.Fragment key={qual}>
                                    {item?.selected?.[qual]?.[0]
                                      ?.isAllDegree ? (
                                      <SkillBox>
                                        {' '}
                                        {console.log(qual, ' :qual')}
                                        Any{' '}
                                        {[qual] == 'UG_DIPLOMA'
                                          ? 'DIPLOMA'
                                          : [qual]}
                                      </SkillBox>
                                    ) : (
                                      <>
                                        {' '}
                                        {item?.selected?.[qual]?.map(
                                          (subitem, subkey) => {
                                            if (true) {
                                              return (
                                                <React.Fragment
                                                  key={subkey + 'subKey'}
                                                >
                                                  {subitem?.streams?.map(
                                                    (stream, streamIndex) => (
                                                      <React.Fragment
                                                        key={
                                                          streamIndex +
                                                          'streamIndex'
                                                        }
                                                      >
                                                        {stream?.specialisations
                                                          ?.length > 0
                                                          ? stream?.specialisations?.map(
                                                              (
                                                                spec,
                                                                specIndex
                                                              ) => {
                                                                if (
                                                                  displayedIntegrations >=
                                                                  showItemCount
                                                                )
                                                                  return null

                                                                displayedIntegrations++
                                                                return (
                                                                  <React.Fragment
                                                                    key={
                                                                      specIndex +
                                                                      'specIndex'
                                                                    }
                                                                  >
                                                                    <SkillBox>
                                                                      {
                                                                        subitem?.shortForm
                                                                      }{' '}
                                                                      -{' '}
                                                                      {
                                                                        stream?.name
                                                                      }{' '}
                                                                      -{' '}
                                                                      {
                                                                        spec?.name
                                                                      }
                                                                    </SkillBox>
                                                                    {specIndex <
                                                                      stream
                                                                        .specialisations
                                                                        .length -
                                                                        1 &&
                                                                      displayedIntegrations <
                                                                        showItemCount && (
                                                                        <Condition>
                                                                          Or
                                                                        </Condition>
                                                                      )}
                                                                  </React.Fragment>
                                                                )
                                                              }
                                                            )
                                                          : displayedIntegrations++ <
                                                              showItemCount && (
                                                              <SkillBox
                                                                key={
                                                                  streamIndex +
                                                                  'streamIndex'
                                                                }
                                                              >
                                                                {
                                                                  subitem?.shortForm
                                                                }{' '}
                                                                - {stream?.name}
                                                              </SkillBox>
                                                            )}
                                                        {streamIndex <
                                                          subitem.streams
                                                            .length -
                                                            1 &&
                                                          displayedIntegrations <
                                                            showItemCount && (
                                                            <Condition>
                                                              Or
                                                            </Condition>
                                                          )}
                                                      </React.Fragment>
                                                    )
                                                  )}
                                                  {subitem?.streams?.length ===
                                                    0 &&
                                                    displayedIntegrations++ <
                                                      showItemCount && (
                                                      <SkillBox
                                                        key={subkey + 'sub'}
                                                      >
                                                        {subitem?.shortForm}
                                                      </SkillBox>
                                                    )}
                                                  {subkey <
                                                    item?.selected?.[qual]
                                                      ?.length -
                                                      1 &&
                                                    displayedIntegrations <
                                                      showItemCount && (
                                                      <Condition>Or</Condition>
                                                    )}
                                                </React.Fragment>
                                              )
                                            }
                                          }
                                        )}
                                      </>
                                    )}
                                    {index < item.qualification.length - 1 && (
                                      <Condition>Or</Condition>
                                    )}
                                  </React.Fragment>
                                ))}

                                {key <
                                  eligibilityCriteria?.degree?.length - 1 && (
                                  <AndDivision>And</AndDivision>
                                )}
                              </React.Fragment>
                            )
                          })}
                          {totalIntegrations > 5 && (
                            <ShowDiv onClick={() => setShowAll(!showAll)}>
                              {showAll ? 'Show Less' : 'Show More'}
                            </ShowDiv>
                          )}
                        </TextWithIcon>
                      </div>
                    )}
                  </StyledPanel>
                  <StyledPanel
                    header="Year of Passing"
                    key="2"
                    isEligible={eligibilityCriteria?.isYearOfPassingEligible}
                  >
                    <YOPText>
                      {' '}
                      {eligibilityCriteria?.yearOfpassing?.role.join(', ')}
                    </YOPText>
                  </StyledPanel>

                  {((
  eligibilityCriteria?.score?.role?.tenthScore &&
  eligibilityCriteria?.score?.role?.tenthScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.twelfthScore &&
  eligibilityCriteria?.score?.role?.twelfthScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.UGScore &&
  eligibilityCriteria?.score?.role?.UGScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.PGScore &&
  eligibilityCriteria?.score?.role?.PGScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.UGDiplomaScore &&
  eligibilityCriteria?.score?.role?.UGDiplomaScore !== '0'
) ||
(
  eligibilityCriteria?.score?.role?.PGDiplomaScore &&
  eligibilityCriteria?.score?.role?.PGDiplomaScore !== '0'
)
                   ) && (
                    <StyledPanel
                      header="Score (Percentage)"
                      key="3"
                      isEligible={eligibilityCriteria?.isScoreEligible}
                    >
                      {/* <YOPText>
            Average mark should be above {viewRoleDetails?.role?.avgScore}% in all
            your exams
          </YOPText> */}
                      {eligibilityCriteria?.score?.role?.tenthScore &&
                        eligibilityCriteria?.score?.role?.tenthScore !==
                          '0' && (
                          <YOPText>
                            10th - Above{' '}
                            {eligibilityCriteria?.score?.role?.tenthScore}%
                          </YOPText>
                        )}
                      {eligibilityCriteria?.score?.role?.twelfthScore &&
                        eligibilityCriteria?.score?.role?.twelfthScore !==
                          '0' && (
                          <YOPText>
                            12th or Equivalent - Above{' '}
                            {eligibilityCriteria?.score?.role?.twelfthScore}%
                          </YOPText>
                        )}
                      {eligibilityCriteria?.score?.role?.UGScore &&
                        eligibilityCriteria?.score?.role?.UGScore !== '0' && (
                          <YOPText>
                            UG - Above{' '}
                            {eligibilityCriteria?.score?.role?.UGScore}%
                          </YOPText>
                        )}
                      {eligibilityCriteria?.score?.role?.UGDiplomaScore &&
                        eligibilityCriteria?.score?.role?.UGDiplomaScore !==
                          '0' && (
                          <YOPText>
                            UG Diploma- Above{' '}
                            {eligibilityCriteria?.score?.role?.UGDiplomaScore}%
                          </YOPText>
                        )}
                      {eligibilityCriteria?.score?.role?.PGScore &&
                        eligibilityCriteria?.score?.role?.PGScore !== '0' && (
                          <YOPText>
                            PG - Above{' '}
                            {eligibilityCriteria?.score?.role?.PGScore}%
                          </YOPText>
                        )}
                      {eligibilityCriteria?.score?.role?.PGDiplomaScore &&
                        eligibilityCriteria?.score?.role?.PGDiplomaScore !==
                          '0' && (
                          <YOPText>
                            PG Diploma- Above{' '}
                            {eligibilityCriteria?.score?.role?.PGDiplomaScore}%
                          </YOPText>
                        )}
                    </StyledPanel>
                  )}
                  <StyledPanel
                    header="Arrears/Backlogs"
                    key="4"
                    isEligible={eligibilityCriteria?.isArrearEligible}
                  >
                    {eligibilityCriteria?.arrear?.roleArrear > 0 && (
                      <>
                        <SkillSubTitle>Current Arrears</SkillSubTitle>
                        <SkillBox>
                          Up to {eligibilityCriteria?.arrear?.roleArrear}{' '}
                          Arrears Allowed
                        </SkillBox>
                      </>
                    )}
                    {eligibilityCriteria?.arrear?.roleHistoryArrear > 0 && (
                      <>
                        <SkillSubTitle>History of Arrears</SkillSubTitle>
                        <SkillBox>
                          Up to {eligibilityCriteria?.arrear?.roleHistoryArrear}{' '}
                          Arrears Allowed
                        </SkillBox>
                      </>
                    )}

                    {eligibilityCriteria?.arrear?.roleHistoryArrear === 0 &&
                      eligibilityCriteria?.arrear?.roleArrear === 0 && (
                        <>
                          <SkillBox>No Arrears Allowed</SkillBox>
                        </>
                      )}
                  </StyledPanel>
                  {eligibilityCriteria?.experience?.role?.length > 1 && 
 !eligibilityCriteria?.experience?.role?.every(item => item === 0) && (
                    <StyledPanel
                      header="Work Experience"
                      key="5"
                      isEligible={eligibilityCriteria?.isExperienceEligible}
                    >
                      <div style={{ display: 'grid', rowGap: '10px' }}>
                        {!eligibilityCriteria?.isExperienceEligible ? (
                          <SkillBoxRed
                            onClick={() => showDrawer(viewRoleDetails)}
                          >
                            Work Experience:
                            {' ' +
                              (date?.minYear +
                                (Number(date?.minYear) <= 1
                                  ? ' yr '
                                  : ' yrs ')) +
                              (date?.minMonth + ' mos ') +
                              (viewRoleDetails?.role?.yearOfExperience?.[1]
                                ? '-' +
                                  (date?.maxYear +
                                    (Number(date?.maxYear) <= 1
                                      ? ' yr '
                                      : ' yrs ')) +
                                  date?.maxMonth +
                                  ' mos'
                                : '')}{' '}
                            <span>
                              <AddPlusRed />
                            </span>
                          </SkillBoxRed>
                        ) : (
                          <>
                            <SkillBox
                              isColor={true}
                              key={'mandatorySkillNames'}
                            >
                              Work Experience:
                              {' ' +
                                (date?.minYear +
                                  (Number(date?.minYear) <= 1
                                    ? ' yr '
                                    : ' yrs ')) +
                                (date?.minMonth + ' mos ') +
                                (viewRoleDetails?.role?.yearOfExperience?.[1]
                                  ? '-' +
                                    (date?.maxYear +
                                      (Number(date?.maxYear) <= 1
                                        ? ' yr '
                                        : ' yrs ')) +
                                    date?.maxMonth +
                                    ' mos'
                                  : '')}{' '}
                            </SkillBox>
                          </>
                        )}
                        {eligibilityCriteria?.experience?.student?.map(
                          (item, index) => (
                            <SkillBox>
                              {item?.organization} (
                              {moment(item?.started_in, 'MM/YYYY').format(
                                'MMMM YYYY'
                              ) +
                                (item?.isCurrentlyWorking
                                  ? '- Present'
                                  : item?.ended_in
                                  ? '-' +
                                    moment(item?.ended_in, 'MM/YYYY').format(
                                      'MMMM YYYY'
                                    )
                                  : '')}
                              )
                            </SkillBox>
                          )
                        )}

                        {/* <SkillBox>
                Ashok Leyland (Jan 2018 - Mar 2018)
                </SkillBox>
                <SkillBox>
                Tata Motors (July 2018 - Nov 2018)
                </SkillBox> */}
                      </div>
                    </StyledPanel>
                  )}
                  {(mandatorySkillNames?.length > 0 ) && (
                    <StyledPanel
                      header="Skills"
                      key="6"
                      isEligible={eligibilityCriteria?.isSkillEligible}
                    >
                      <div>
                        <SkillList>
                          {/* Mandatory Skills Section */}
                          {mandatorySkillNames?.filter(skill => skill.isMandatory)?.length > 0 && (
                            <>
                              <SkillSubTitle>Mandatory Skills</SkillSubTitle>
                              <FlexWrap
                                wrap
                                gap="10px"
                                padding="5px 0px 0px 0px"
                                disabled={isOptOut == 1 || isOptOut == 4}
                              >
                                {mandatorySkillNames
                                  ?.filter(skill => skill.isMandatory)
                                  ?.map((tag, index) => (
                                    <React.Fragment key={index + 'mandatorySkill'}>
                                      {eligibilityCriteria?.isSkillEligible ? (
                                        <SkillBox>
                                          {tag.name}
                                        </SkillBox>
                                      ) : !eligibilityCriteria?.isSkillEligible &&
                                        tag?.isMatch ? (
                                        <SkillBox isColor={true}>
                                          {tag.name}
                                        </SkillBox>
                                      ) : (
                                        <SkillBoxRed
                                          onClick={() => showDrawer(viewRoleDetails)}
                                          disabled={isOptOut == 1 || isOptOut == 4}
                                        >
                                          {tag.name}{' '}
                                          <span>
                                            <AddPlusRed />
                                          </span>
                                        </SkillBoxRed>
                                      )}
                                      {mandatorySkillNames.filter(skill => skill.isMandatory).length !==
                                        index + 1 && <div>,</div>}
                                    </React.Fragment>
                                  ))}
                              </FlexWrap>
                            </>
                          )}

                          {/* Non-Mandatory Skills Section */}
                          {mandatorySkillNames?.filter(skill => !skill.isMandatory)?.length > 0 && (
                            <>
                              <SkillSubTitle>Non-Mandatory Skills</SkillSubTitle>
                              <FlexWrap
                                wrap
                                gap="10px"
                                padding="5px 0px 0px 0px"
                                disabled={isOptOut == 1 || isOptOut == 4}
                              >
                                {mandatorySkillNames
                                  ?.filter(skill => !skill.isMandatory)
                                  ?.map((tag, index) => (
                                    <React.Fragment key={index + 'nonMandatorySkill'}>
                                      {eligibilityCriteria?.isSkillEligible ? (
                                        <SkillBox>
                                          {tag.name}
                                        </SkillBox>
                                      ) : !eligibilityCriteria?.isSkillEligible &&
                                        tag?.isMatch ? (
                                        <SkillBox isColor={true}>
                                          {tag.name}
                                        </SkillBox>
                                      ) : (
                                        <SkillBoxRed
                                          onClick={() => showDrawer(viewRoleDetails)}
                                          disabled={isOptOut == 1 || isOptOut == 4}
                                        >
                                          {tag.name}{' '}
                                          <span>
                                            <AddPlusRed />
                                          </span>
                                        </SkillBoxRed>
                                      )}
                                      {mandatorySkillNames.filter(skill => !skill.isMandatory).length !==
                                        index + 1 && <div>,</div>}
                                    </React.Fragment>
                                  ))}
                              </FlexWrap>
                            </>
                          )}
                        </SkillList>
                      </div>
                    </StyledPanel>
                  )}
                  {(eligibilityCriteria?.location?.role?.length > 0 || eligibilityCriteria?.location?.roleIsAnyWhere) && (
                    <StyledPanel
                      header="Location"
                      key="7"
                      isEligible={eligibilityCriteria?.isLocationEligible}
                    >
                      {eligibilityCriteria?.location?.roleIsAnyWhere ? (
                        <SkillBox key={'locationAny'}>
                          Anywhere
                        </SkillBox>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            gap: '5px',
                            flexWrap: 'wrap',
                            cursor:
                              isOptOut == 1 || isOptOut == 4
                                ? 'not-allowed'
                                : 'pointer',
                          }}
                        >
                          {eligibilityCriteria?.location?.role !== undefined &&
                            eligibilityCriteria?.location?.role.map(
                              (item, index) => (
                                <>
                                  {eligibilityCriteria?.isLocationEligible ? (
                                    <SkillBox key={index + 'locationAny'}>
                                      {item.name ?? item.state_name}
                                    </SkillBox>
                                  ) : !eligibilityCriteria?.isLocationEligible &&
                                    item?.isMatch ? (
                                    <SkillBox
                                      isColor={true}
                                      key={index + 'locationAny'}
                                    >
                                      {item.name ?? item.state_name}
                                    </SkillBox>
                                  ) : (
                                    <SkillBoxRed
                                      onClick={() =>
                                        showDrawer(viewRoleDetails)
                                      }
                                      disabled={isOptOut == 1 || isOptOut == 4}
                                    >
                                      {item.name ?? item.state_name}{' '}
                                      <span>
                                        <AddPlusRed />
                                      </span>
                                    </SkillBoxRed>
                                  )}
                                </>
                                // <SkillBoxRed key={item.id}>
                                //   {item.name}{' '}
                                //   <span>
                                //     <AddPlusRed />
                                //   </span>
                                // </SkillBoxRed>
                              )
                            )}
                        </div>
                      )}
                    </StyledPanel>
                  )}
                  {viewRoleDetails?.role?.questionBankRoleMap?.length > 0 && !eligibilityCriteria?.isQuestionarieEligible && (
                    <StyledQuestion  onClick={() =>
                      showDrawer(viewRoleDetails)
                    }>Qualifying questions</StyledQuestion>
                  )}

                  {eligibilityCriteria?.questionarie?.student?.length > 0 &&
                    eligibilityCriteria?.questionarie?.jobRoleData?.length >
                      0 && (
                      <StyledQuestion isEligible={true}>
                        Qualifying questions
                      </StyledQuestion>
                    )}

                  {viewRoleDetails?.isRestricted &&
                    !viewRoleDetails?.isExpired &&
                    viewRoleDetails?.role?.jobCategory === 'PLACEMENT' &&
                    viewRoleDetails?.role?.status != -1 &&
                    viewRoleDetails?.isApplied != 1 &&
                    viewRoleDetails?.isApplied != -1 &&
                    !viewRoleDetails?.isExternalLink && (
                      <StyledPanel
                        header="Need TPO approval"
                        key="8"
                        isEligible={
                          !viewRoleDetails?.isRestricted ||
                          viewRoleDetails?.tpoStatus == 0
                        }
                      >
                        <>
                          {messages?.map((msg, index) => (
                            <GetTPOContent
                              key={msg.id}
                              dangerouslySetInnerHTML={{
                                __html: msg?.message + '.',
                              }}
                            />
                          ))}
                          {/* {viewRoleDetails?.tpoStatus != 0 &&
                            viewRoleDetails?.tpoStatus != -1 &&
                            studentData?.status != -1 &&
                            optoutStatus?.optoutStatus?.currentCourse
                              ?.optOutStatus != 1 &&
                            optoutStatus?.optoutStatus?.currentCourse
                              ?.optOutStatus != 4 && (
                              <Button.Primary
                                onClick={() => getApproval()}
                                text={'Get TPO approval'}
                                width={'100%'}
                                disabled={!eligibilityCriteria?.isEligible}
                              />
                            )} */}

                          {/* {viewRoleDetails?.tpoStatus == 0 && (
                            <Button.SecondaryColor
                              color={'#3249D7'}
                              background={'#EAEDFB'}
                              text={'TPO Approval Sent'}
                              width={'100%'}
                              style={{
                                whiteSpace: 'pre-line',
                                lineHeight: '1.2',
                                textAlign: 'center',
                              }}
                            />
                          )} */}
                           {/* {!eligibilityCriteria?.isEligible &&
                            studentData?.status != -1 ? (
                          <Flex style={{ padding: '20px 0px', gap: '15px' }}>
                           
                              <>
                                <ExclamationIcon />
                                <GetTPOContent>
                                  This button will be activated once all the
                                  "Eligibility Criteria" are updated.
                                </GetTPOContent>
                              </>
                           
                         
                          </Flex>
                           ) : (
                            <></>
                        )} */}
                        </>
                      </StyledPanel>
                    )}
                </StyledCollapse>
                {viewRoleDetails?.isApplied != 1  ? (
                  DateCompare()
                ) : viewRoleDetails?.isApplied === -1 ? (
                  <Button.SecondaryColor text={'Applied'} width={'100%'} />
                ) : (
                  <Button.SecondaryColor text={'Applied'} width={'100%'} />
                )}

{viewRoleDetails?.isApplied === 0 &&(
                <Flex style={{ padding: '20px 0px', gap: '15px' }}>
                  {eligibilityCriteria?.isEligible ? (
                    <>
                      <Happly />
                      <InnerBodyText>
                        Great! You are eligible for the role based on your
                        degree and department.
                      </InnerBodyText>
                    </>
                  ) : (
                    <>
                      <UnHapply />
                      <InnerBodyText>
                        Oh no! You are not eligible to apply for this role.
                        {JBIMS_INSITITUTE_CAMPUS_ID !== campusDetails?.id && ` Check your eligibility and update your profile.`}
                      </InnerBodyText>
                    </>
                  )}
                </Flex>
)}
              </RightContentOuter>
            </Col>
          </RowContainer>
        </OuterDiv>
      </SectionWrapper>
}
<ApplyResumePopup
  visible={resumePopupVisible}
  onClose={() => setResumePopupVisible(false)}
  // resumeFiles={resumeFilesLocal}
  // defaultId={defaultResumeId}
  onApply={onApplyWithResume}
  getStudentResumeData={getStudentResumeData}
  // studentId={studentId}
  studentUpdateAt={studentDetails?.updateAt}
  studentDetails={studentDetails}
/>
      <ConfirmationModal
        onCloseClick={() => onConfirmModalClose()}
        open={applyBeforeConfirm}
        description={
          studentRules?.applyLimit?.limit
            ? `You have <span>${
                studentRules?.applyLimit?.limit -
                  studentRules?.applyLimit?.used <
                0
                  ? 0
                  : studentRules?.applyLimit?.limit -
                    studentRules?.applyLimit?.used
              }</span> application chances left out of <span>${
                studentRules?.applyLimit?.limit
              }</span>`
            : `Are you sure to apply for this job?`
        }
        title={''}
        onApplyClick={onRoleAccept}
        confirm={false}
        applyText={'Apply'}
        dynamicContent={true}
      />
      <ConfirmationModal
        onCloseClick={() => onConfirmModalClose()}
        open={isApproval}
        description1={
          studentRules?.applyLimit?.limit
            ? `You have <span>${
                studentRules?.applyLimit?.limit -
                  studentRules?.applyLimit?.used <
                0
                  ? 0
                  : studentRules?.applyLimit?.limit -
                    studentRules?.applyLimit?.used
              }</span> application chances left out of <span>${
                studentRules?.applyLimit?.limit
              }</span>`
            : null
        }
        description={'Are you sure to apply for this job with'}
        title={'TPO approval'}
        onApplyClick={onApprovalClick}
        confirm={false}
        applyText={'Request TPO approval'}
        dynamicContent={false}
        tpoApproval={true}
        message={messagePopup}
      />
      <ConfirmationModal
        onCloseClick={() => onConfirmModalClose()}
        open={externalConfirm}
        description={`To apply for this  ${
          checkJobCategory(viewRoleDetails?.role?.jobCategory)
        }, you must use their company site. Open a new window? `}
        title={''}
        onApplyClick={onExternalRedirect}
        confirm={false}
      />

      <ConfirmationModal
        onCloseClick={() => onExternalApplyClose()}
        open={externalLinkApply}
        description={`Did you apply for the "${
          viewRoleDetails?.role?.tittle
        }" position on ${
          viewRoleDetails?.role?.company?.companyName ||
          viewRoleDetails?.role?.corporate?.name
        } company site? `}
        title={''}
        onApplyClick={onExternalApply}
        confirm={false}
      />
      <SuccessModal
        open={appliedSuccessModal}
        message={'Applied'}
        onCloseClick={onConfirmModalClose}
        title={''}
      />
      <SuccessModal
        open={isApprovalSuccessModal}
        message={'Request sent!'}
        onCloseClick={onConfirmModalClose}
        title={''}
      />
      {drawer && (
        <ConfirmDrawer
          drawer={drawer}
          setDrawer={setDrawer}
          dataSelected={viewRoleDetails}
          onApplyClick={onApplyClick}
          collegeData={collegeData}
        />
      )}
      {questionnaireModal && (
        <QuestionnaireModal
          visible={questionnaireModal}
          onClose={closeQuestionnaireModal}
          corporateId={params.CorpID}
          roleId={params.JobID}
          viewRoleDetails={viewRoleDetails}
          setIsApproval={setIsApproval}
          setExternalConfirm={setExternalConfirm}
          setQuestionnaireModal={setQuestionnaireModal}
          setResumePopupVisible={setResumePopupVisible}
          setExternalResumeApply={setExternalResumeApply}
          setApprovalResumeApply={setApprovalResumeApply}

        />
      )}
      <Modal
        width={'585px'}
        open={emailModel}
        footer={null}
        onCancel={handleEmailCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <img src={Emptystates} alt="EmptyState" />
            </Flex>

            <MailSubHeading>Share Job with your friends</MailSubHeading>
          </Content>
          <Form
            style={{ width: '100%' }}
            scrollToFirstError
            onFinish={sendEmailOTP}
            id={'emailForm'}
            layout="vertical"
          >
            <Label>Your friend's email address *</Label>
            <AntdInput
              AntdInput
              placeholder="eg:harry@yahoo.com"
              width="100%"
              name="Email"
              onChange={onEmailEntered}
              rules={[
                {
                  required: true,
                  message: 'Please enter primary email!',
                },
                {
                  type: 'email',
                  message: 'Please enter valid email',
                },
              ]}
            />

            <DisplayPad>
              <Button.Primary
                htmlType="submit"
                text={'Submit'}
                width={'100%'}
                padding={'10px'}
              />
            </DisplayPad>
          </Form>
        </RowPadding>
      </Modal>
      {/* {modalVisible && (
        <CustomModal
          visible={modalVisible}
          onClose={closeModal}
          onUpdate={openModal}
          message="You are not eligible for this role !"
        />
      )} */}

      {roleDrawer && (
        <SkillBasedRoleModal
          setSelected={setSelected}
          setRoleDrawer={setRoleDrawer}
          setSkillVisible={setSkillVisible}
          setLocationVisible={setLocationVisible}
          setExpVisible={setExpVisible}
          skillVisible={skillVisible}
          locationVisible={locationVisible}
          expVisible={expVisible}
          roleDrawer={roleDrawer}
          eligibleList={eligibleList}
          roleFloatList={roleFloatList}
          setWorkExperienceDrawer={setWorkExperienceDrawer}
          getFunctionsList={getFunctionsList}
          updateRoleFloatDetails={updateRoleFloatDetails}
          getEligibleDetails={getEligibleDetails}
          UpdatedSkills={UpdatedSkills}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          getListOfSkills={getListOfSkills}
          setUpdateResponse={setUpdateResponse}
          updateResponse={updateResponse}
          setQuestionnaireModal={setQuestionnaireModal}
          selectedNew={selectedNew}
          onApplyClick={onApplyClickSkilled}
          fetchEligleDetails={fetchEligleDetails}
          eligibilityCriteria={eligibilityCriteria}
          setInternshipDrawer={setInternshipDrawer}
          setProjectDrawer={setProjectDrawer}
          setCourseTrainingDrawer={setCourseTrainingDrawer}
          setEduModalVisible={setEduModalVisible}
          fetchEligleDetailsNotLoading={fetchEligleDetailsNotLoading}
        />
      )}

      {workExperienceDrawer && (
        <WorkExperienceModal
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          drawerStatus={workExperienceDrawer}
          setdrawerStatus={setWorkExperienceDrawer}
          studentFormData={studentDetails}
          updateStudentData={updateStudentData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          listOfStudentSkills={listOfStudentSkills}
          roleDrawer={roleDrawer}
          setRoleDrawer={setRoleDrawer}
          getEligibleDetails={getEligibleDetails}
          getRoleFloatDetails={getRoleFloatDetails}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
          pendingData={pendingData}
        />
      )}

      {internshipDrawer && (
        <InternshipDrawerModal
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          drawerStatus={internshipDrawer}
          setdrawerStatus={setInternshipDrawer}
          studentFormData={studentDetails}
          updateStudentData={updateStudentData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          listOfStudentSkills={listOfStudentSkills}
          roleDrawer={roleDrawer}
          setRoleDrawer={setRoleDrawer}
          getEligibleDetails={getEligibleDetails}
          getRoleFloatDetails={getRoleFloatDetails}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
          pendingData={pendingData}
        />
      )}
       {projectDrawer && (
        <ProjectModal
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          drawerStatus={projectDrawer}
          setdrawerStatus={setProjectDrawer}
          studentFormData={studentDetails}
          updateStudentData={updateStudentData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          listOfStudentSkills={listOfStudentSkills}
          roleDrawer={roleDrawer}
          setRoleDrawer={setRoleDrawer}
          getEligibleDetails={getEligibleDetails}
          getRoleFloatDetails={getRoleFloatDetails}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
          pendingData={pendingData}
        />
      )}
      {courseTrainingDrawer && (
        <CourseTrainingModal
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          drawerStatus={courseTrainingDrawer}
          setdrawerStatus={setCourseTrainingDrawer}
          studentFormData={studentDetails}
          updateStudentData={updateStudentData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          listOfStudentSkills={listOfStudentSkills}
          roleDrawer={roleDrawer}
          setRoleDrawer={setRoleDrawer}
          getEligibleDetails={getEligibleDetails}
          getRoleFloatDetails={getRoleFloatDetails}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
          pendingData={pendingData}
        />
      )}
      {eduModalVisible && (
        <EducationalModal
          setExpDrawer={setExpDrawer}
          expDrawer={expDrawer}
          drawerStatus={eduModalVisible}
          setdrawerStatus={setEduModalVisible}
          modalVisible={eduModalVisible}
          setModalVisible={setEduModalVisible}
          studentFormData={studentDetails}
          pendingData={pendingData}
          updateStudentData={updateStudentData}
          getPendingData={getPendingData}
          getFunctionsList={getFunctionsList}
          functionsList={functionsList}
          listOfStudentSkills={listOfStudentSkills}
          getListOfState={getListOfState}
          getListOfCity={getListOfCity}
          getListOfCountries={getListOfCountries}
          roleDrawer={roleDrawer}
          setRoleDrawer={setRoleDrawer}
          getEligibleDetails={getEligibleDetails}
          getRoleFloatDetails={getRoleFloatDetails}
          itemId={selected}
          loading={loading}
          setLoading={setLoading}
          getListOfSkills={getListOfSkills}
          searchAPI={searchAPI}
          deleteEducation={deleteEducation}
        />
      )}
      <ProfileFormModal
          visible={modalVisibleData}
          onClose={() => setModalVisibleData(false)}
          onSubmit={handleSubmit}
          studentData={studentData}
          getListOfCountries={getListOfCountries}
          getListOfState={getListOfState}
          getListOfCity={getListOfCity}
          searchAPI={searchAPI}
          getListOfSkills={getListOfSkills}
          stateList={stateList}
          studentFormData={studentFormData}
          updateStudentData={updateStudentData}
          updateCvDetails={updateCvDetails}
          getStudentData={getStudentData}
          fetchStudentData={fetchStudentData}
          showDrawer={showDrawer}
          viewRoleDetails={viewRoleDetails}
          pendingData={pendingData}
          onStartCvUpload={() => {
            // open progress modal & close form
            setCvProgPercent(0)
            setCvProgVisible(true)
            setModalVisibleData(false) // closes ProfileFormModal
          }}
          onCvProgress={p => setCvProgPercent(p)} // update %
          onFinishCvUpload={() => {
            // close progress & reopen form
            setCvProgVisible(false)
            setModalVisibleData(true)
          }}
          getSingleRoleDetails={getSingleRoleDetails}
          fetchEligleDetails={fetchEligleDetails}
          getCities={getCities}
          setApplyBeforeConfirm={setApplyBeforeConfirm}
          deleteEducation={deleteEducation}
          setExternalConfirm={setExternalConfirm}
        />
      

      {cvProgVisible && (
        <CvProgressModal visible={cvProgVisible} progress={cvProgPercent} />
      )}
      {/* <PopModal
  visible={modalVisibleData}
  onClose={() => setModalVisibleData(false)}
  onSubmit={handleSubmit}
  studentData={studentData}
  studentFormData={studentDetails}
  getListOfCountries={getListOfCountries}
  getListOfState={getListOfState}
  getListOfCity={getListOfCity}
  searchAPI={searchAPI}
  getListOfSkills={getListOfSkills}
  countryList={countryList}
  stateList={stateList}
  updateStudentData={updateStudentData}
  updateCvDetails={updateCvDetails}
  getStudentData={getStudentData}
  deleteEducation={deleteEducation}
  getCities={getCities}
  onStartCvUpload={() => {
    // open progress modal & close form
    setCvProgPercent(0)
    setCvProgVisible(true)
    setModalVisibleData(false) // closes ProfileFormModal
  }}
  onCvProgress={p => setCvProgPercent(p)} // update %
  onFinishCvUpload={() => {
    // close progress & reopen form
    setCvProgVisible(false)
    setModalVisibleData(true)
  }}
  cvDetails={studentData?.cvDetails}
/> */}
    </>
  )
}
export default ViewSingleRole
